import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Banner from './components/Banner';
import Footer from './components/Footer';
import TermsOfUse from './pages/tou'; // Import TermsOfUse
import PrivacyPolicy from './pages/pp'; // Import PrivacyPolicy
import Login from './pages/Login'; // Import PrivacyPolicy
import useLocale from './hooks/useLocale';
import Register from './pages/Register';
import Home from './pages/Home';
import Browse from './pages/Browse';
import Upload from './pages/Upload';
import ForgotPassword from './pages/ForgotPassword'; // Adjust path
import ResetPassword from './pages/ResetPassword';
import Settings from './pages/Settings';
import { LocaleProvider } from './context/LocalContext'; // Adjust path if needed
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute'; // <--- We'll create this next


function App() {
  return (
    <LocaleProvider>
    <AuthProvider>

    <Router>
      <header>
        <Banner />
      </header>
      <main>
        <section id="hero">
          <div id="hero-content">
          <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tou" element={<TermsOfUse />} />
        <Route path="/pp" element={<PrivacyPolicy />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
              path="/home"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
        <Route
              path="/browse"
              element={
                <ProtectedRoute>
                  <Browse />
                </ProtectedRoute>
              }
            />
            <Route
              path="/upload"
              element={
                <ProtectedRoute>
                  <Upload />
                </ProtectedRoute>
              }
              />
      </Routes>
          </div>
        </section>
      </main>

      <Footer />

    </Router>
    </AuthProvider>
    </LocaleProvider>
  );
}

function HomePage() {
  const { handleLanguageChange, t } = useLocale();

  return (
    <div>
      <button onClick={() => handleLanguageChange('en')}>English</button>
      <button onClick={() => handleLanguageChange('es')}>Spanish</button>
      <h1>{t('homepage_short_welcome', 'Welcome to AstronomyShare.com')}</h1>
            <p>{t('homepage_paragraph_one', 'Something went terribly wrong')}</p> 
            <p>{t('homepage_paragraph_two', 'With the localization strings')}</p> 
    </div>
  );
}

export default App;
